import { BuilderView } from '../workflow-builder-edit/types';
import { CHANNEL_TO_PRODUCT_MAP } from 'src/utils/constants';

export const NO_SELECTED_INSTRUCTION = '';
export const NO_SELECTED_CONTENT_SNIPPET = '';
export const PREVIEW_ALL = 'preview_all';
export const PREVIEW_NONE = '';
export const ORANGE = '#F66E13';
export const PREVIEW_PARAMS_NAME = 'previewMode';

export const SUPPORTED_CHANNELS = [
  'workflow_builder',
  'api',
  'playbook',
  'slack',
  'interactive_email',
  'voice',
] as const;

export type SupportedChannel = (typeof SUPPORTED_CHANNELS)[number];

export const VOICE_KNOWLEDGE_COACHING_FEATURE_FLAG = 'voice_knowledge_coaching';
export const VOICE_CONTENT_SNIPPETS_FEATURE_FLAG = 'voice_content_snippets';

interface SupportedChannelsOptions {
  isVoiceEnabled?: boolean;
}

export const isAiInstructionsSupportedForView = (
  view: BuilderView,
  options?: SupportedChannelsOptions,
): boolean => {
  const product = CHANNEL_TO_PRODUCT_MAP[view];
  return getSupportedChannels(options).includes(product as SupportedChannel);
};

export const getSupportedChannels = ({
  isVoiceEnabled = true,
}: SupportedChannelsOptions = {}): SupportedChannel[] =>
  SUPPORTED_CHANNELS.filter(channel => isVoiceEnabled || channel !== 'voice');
